export const DEFAULT_CLIP_DURATION = 30;
export const MINIMUM_TIME = 5;
export const HOUR_IN_SECONDS = 3600;
export const ERROR_MESSAGE_TIME_DURATION = 'Clip should be at least 5 seconds long';
export const ERROR_MESSAGE_TIME_FINAL = 'Clip should be start time must be less than the duration time';
export const MESSAGE_TIMESTAMP = 'Enter timestamps in HH:MM:SS format';
export const MESSAGE_SAVE = 'Save Clip';
export const MESSAGE_TYPE_INPUT = 'Please input a time';
export const INIT_INPUT = 'init';
export const END_INPUT = 'end';

const HOUR_MASK = [/\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/];
const HOUR_FORMAT = 'HH:mm:ss';
const MINUTES_MASK = [/\d/, /\d/, ':', /\d/, /\d/];
const MINUTES_FORMAT = 'mm:ss';

export const getMask = (duration) => (duration >= HOUR_IN_SECONDS ? HOUR_MASK : MINUTES_MASK);
export const getFormat = (duration) => (duration >= HOUR_IN_SECONDS ? HOUR_FORMAT : MINUTES_FORMAT);
